var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-plyr',{ref:"plr",attrs:{"options":_vm.options}},[_c('video',{attrs:{"controls":"","crossorigin":"","playsinline":"","autoplay":_vm.isAutoplay}},[_c('source',{attrs:{"src":_vm.src}})])])}
var staticRenderFns = []

export { render, staticRenderFns }